module.exports = __webpack_public_path__ + "img/img0105.aa4e97eb.png";